<template>
  <Modal
    :show="true"
    centered
    size="xxl"
    title="Detalle de Liquidación"
    @hide="$emit('hide')"
    body-class="p-0"
  >
    <Spinner v-if="loading.view" class="py-3"></Spinner>
    <DetalleLiquidacion
      v-else
      :agencia="detalleLiquidacion.agencia"
      :codigo="detalleLiquidacion.codigo"
      :pasajero="detalleLiquidacion.pasajero"
      :idioma="detalleLiquidacion.idioma"
      :pax="detalleLiquidacion.pax"
      :chd="detalleLiquidacion.chd"
      :fecha="detalleLiquidacion.fecha"
      :items="detalleLiquidacion.items"
    />
  </Modal>
</template>

<script>
import LiquidacionDetalleTable from "./LiquidacionDetalleTable.vue";
import Spinner from "../../shared/components/Spinner.vue";
import Modal from "../../shared/components/Modal.vue";
import DetalleLiquidacion from "./DetalleLiquidacion.vue";

export default {
  components: { Modal, Spinner, LiquidacionDetalleTable, DetalleLiquidacion },
  props: {
    show: {
      type: Boolean,
      default: true
    },
    record: {
      type: null,
      default: null
    },
    mode: {
      type: String,
      default: "normal"
    }
  },
  data() {
    return {
      loading: {
        view: true,
        save: false
      },
      detalleLiquidacion: {
        agencia: "",
        codigo: "",
        pasajero: "",
        idioma: "",
        pax: "",
        chd: "",
        fecha: "",
        items: []
      }
    };
  },
  async created() {
    const vm = this;
    try {
      const response = await vm.axios.get(
        `/liquidaciones/${vm.record.idLiquidacion}`
      );

      const { detalle: items, liquidacion, registro } = response.data.content;

      this.detalleLiquidacion.agencia = liquidacion.agencia.nombre;
      this.detalleLiquidacion.codigo = registro.codigo;
      this.detalleLiquidacion.pasajero = liquidacion.pasajero;
      this.detalleLiquidacion.idioma = registro.idioma.abreviatura;
      this.detalleLiquidacion.pax = liquidacion.pax;
      this.detalleLiquidacion.chd = liquidacion.ninos;
      this.detalleLiquidacion.fecha = this.$options.filters.date(
        liquidacion.fechaHora
      );
      this.detalleLiquidacion.items = items.map(item => ({
        ...item,
        fecha: this.$options.filters.date(item.fecha),
        monto: item.precio,
        tipo: item.servicioTipo
      }));

      vm.loading.view = false;
    } catch (err) {
      return;
    }
  }
};
</script>
